module.exports = __webpack_public_path__ + "img/pro_thirteen_8.26048e76.jpg";